<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="active ? 'Hide notes' : 'Show notes'"
        :active="active"
        @menuClick="toggleNotes()">
        <DocumentTextIcon class="size-6 " />
    </MenuBase>
</template>
<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { DocumentTextIcon } from '@heroicons/vue/24/outline';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['toggleNotes'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top',
        validator: (value) => {
            return ['top', 'bottom', 'left', 'right'].includes(value);
        }
    },
    active: {
        type: Boolean,
        default: false
    }
})

const active = ref(props.active);

const toggleNotes = () => {
    active.value = !active.value;
    emit('toggleNotes', active.value);
    appEvents.emit('toggleNotes', active.value);
}
appEvents.on('toggleNotes', (value) => {
    active.value = value;
});
</script>